import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import ReportePedidos from '../../Components/Admin/ReportePedidos/ReportePedidos'
import ReporteCajas from '../../Components/Admin/ReporteCajas/ReporteCajas'
import { usePlan } from '../../Components/PlanContext'

export default function Reportes() {
    const { isPlus } = usePlan();
    const [tab, setTab] = useState('pedidos');

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        marginBottom: '20px',
                        borderBottom: '2px solid #e9ecef',
                        paddingBottom: '0',
                    }}>
                        <button
                            onClick={() => setTab('pedidos')}
                            style={{
                                padding: '12px 20px',
                                background: 'transparent',
                                border: 'none',
                                borderBottom: tab === 'pedidos' ? '3px solid #0d6efd' : '3px solid transparent',
                                marginBottom: '-2px',
                                color: tab === 'pedidos' ? '#0d6efd' : '#6c757d',
                                fontWeight: 600,
                                fontSize: '14px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                            }}
                        >
                            <FontAwesomeIcon icon={faClipboardList} /> Pedidos
                        </button>
                        {isPlus && (
                            <button
                                onClick={() => setTab('cajas')}
                                style={{
                                    padding: '12px 20px',
                                    background: 'transparent',
                                    border: 'none',
                                    borderBottom: tab === 'cajas' ? '3px solid #0d6efd' : '3px solid transparent',
                                    marginBottom: '-2px',
                                    color: tab === 'cajas' ? '#0d6efd' : '#6c757d',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                }}
                            >
                                <FontAwesomeIcon icon={faCashRegister} /> Cajas
                            </button>
                        )}
                    </div>

                    {tab === 'pedidos' && <ReportePedidos />}
                    {tab === 'cajas' && isPlus && <ReporteCajas />}
                </div>
            </section>
        </div>
    )
}
